/**
 * Created by jiachenpan on 16/11/18.
 */
import Decimal from 'decimal.js';
import dayjs from 'dayjs';

export function parseTime(time, cFormat) {
    if(arguments.length === 0) {
        return null;
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}';
    let date;
    if(typeof time === 'object') {
        date = time;
    }else {
        if(('' + time).length === 10) time = parseInt(time) * 1000;
        date = new Date(time);
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    };
    const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
        let value = formatObj[key];
        if(key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1];
        if(result.length > 0 && value < 10) {
            value = '0' + value;
        }
        return value || 0;
    });
    return time_str;
}

export function parseTimeHI(time) {
    return parseTime(time, '{h}:{i}');
}

export function parseTimeYMD(time) {
    return parseTime(time, '{y}-{m}-{d}');
}

export function formatTime(time, option) {
    time = +time * 1000;
    const d = new Date(time);
    const now = Date.now();

    const diff = (now - d) / 1000;

    if(diff < 30) {
        return '刚刚';
    }else if(diff < 3600) { // less 1 hour
        return Math.ceil(diff / 60) + '分钟前';
    }else if(diff < 3600 * 24) {
        return Math.ceil(diff / 3600) + '小时前';
    }else if(diff < 3600 * 24 * 2) {
        return '1天前';
    }
    if(option) {
        return parseTime(time, option);
    }else {
        return d.getMonth() + 1 + '月' + d.getDate() + '日' + d.getHours() + '时' + d.getMinutes() + '分';
    }
}

export function debounceAndThrottle(func, wait, immediate) {
    let timeout, args, context, timestamp, result;

    const later = function() {
        // 据上一次触发时间间隔
        const last = +new Date() - timestamp;

        // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
        if(last < wait && last > 0) {
            timeout = setTimeout(later, wait - last);
        }else {
            // clearTimeout(timeout);
            timeout = null;
            // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
            if(!immediate) {
                result = func.apply(context, args);
                if(!timeout) context = args = null;
            }
        }
    };

    return function(...args) {
        context = this;
        timestamp = +new Date();
        const callNow = immediate && !timeout;
        // 如果延时不存在，重新设定延时
        if(!timeout) timeout = setTimeout(later, wait);
        if(callNow) {
            result = func.apply(context, args);
            context = args = null;
        }

        return result;
    };
}

export function debounce(fn, delay) {
    let timer = null;
    return function() {
        const args = arguments; // 参数是event或其他自定义参数
        const context = this;// 指向绑定某个事件的元素或执行该方法的对象
        if(timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(function() {
            fn.apply(context, args);
            timer = null;
        }, delay);
    };
}

/**
 * 判断两个时间是否相等
 * @param equal 是否包含相等的情况，默认包含
 * @param beginDate 第一个时间
 * @param endDate   第二个时间
 * @return endDate >= beginDate = true
 *  */
export function dateCompare(beginDate, endDate, equal = true) {
    if(!beginDate || !endDate) return;

    // 处理一个带时间一个不带的情况，统一只比较日期
    var begin = beginDate.indexOf(' ') > 0 && endDate.indexOf(' ') == -1 ? beginDate.split(' ')[0] : beginDate;
    var end = endDate.indexOf(' ') > 0 && beginDate.indexOf(' ') == -1 ? endDate.split(' ')[0] : endDate;

    return equal ? dayjs(begin).valueOf() <= dayjs(end).valueOf() : dayjs(begin).valueOf() < dayjs(end).valueOf();
}

// 对象转链接参数格式
export function urlParamStr(param) {
    // 确保param是一个对象，避免异常输入
    if(typeof param !== 'object' || param === null) {
        throw new TypeError('Expected an object for param');
    }

    // 初始化str时不需要设置为空字符串
    let first = true;
    let str = '';

    // 循环处理每个参数
    for(const key in param) {
        // 忽略非自有属性，增加代码健壮性
        if(!param.hasOwnProperty(key)) {
            continue;
        }

        // 验证参数值是否存在
        const value = param[key];
        if(value === undefined || value === null) {
            continue;
        }

        // 处理第一个参数，避免添加多余的"&"
        if(!first) {
            str += '&';
        }else {
            first = false;
        }

        // 对参数名和值进行编码
        const encodedKey = encodeURIComponent(key);
        const encodedValue = encodeURIComponent(value);

        // 拼接参数
        str += `${encodedKey}=${encodedValue}`;
    }

    return str;
}

/**
 * @param {string} url
 * @returns {Object}
 */
export function param2Obj(url) {
    try {
        // 使用 URLSearchParams API 来解析查询字符串，提高性能和可读性
        const searchParams = new URLSearchParams(url.split('?')[1]);
        const result = {};

        // 遍历所有参数，这样可以避免因直接JSON.parse带来的安全风险
        searchParams.forEach((value, key) => {
        // 对键值对进行处理，解决编码不一致问题
            const decodedKey = decodeURIComponent(key);
            const decodedValue = decodeURIComponent(value);

            // 处理重复键的情况，使用数组来存储重复的值
            if(result.hasOwnProperty(decodedKey)) {
                if(!Array.isArray(result[decodedKey])) {
                    // 如果之前存储的值不是数组，则将其转换为数组
                    result[decodedKey] = [result[decodedKey]];
                }
                result[decodedKey].push(decodedValue);
            }else {
                result[decodedKey] = decodedValue;
            }
        });

        return result;
    } catch (error) {
        // 异常处理：捕获并处理可能发生的异常
        console.error('Error parsing URL parameters:', error);
        return {}; // 在出错时返回空对象，避免影响后续逻辑
    }
}

// js 计算某个时间 前n天或后n天
// example 前15天addDays(date, -15) 后15天addDays(date, 15)
export function addDays(date, AddDayCount) {
    return dayjs(date).add(AddDayCount, 'day').format('YYYY-MM-DD');
}

// 计算天数差的函数，通用
export function getDays(sDate1, sDate2) { // sDate1和sDate2是2006-12-18格式
    return Math.abs(dayjs(sDate1).diff(dayjs(sDate2), 'day'));
}

export function addMonth(date, months) {
    return dayjs(date).add(months, 'month').format('YYYY-MM-DD');
}

export function natureMonth(date, months) {
    if(!date || !months) return date;
    return addMonth(date, months);
}

export function addYear(dateStr, years) {
    var date = new Date(dateStr);
    date.setFullYear(date.getFullYear() + years);
    date.setDate(date.getDate());
    return parseTime(date, '{y}-{m}-{d}');
}

// 判断图片是否加载成功
export function loadImageAsync(item) {
    const image = new Image();
    image.src = item.src;
    const promise = new Promise((resolve, reject) => {
        image.onload = function() {
            resolve(true);
        };
        image.onerror = function(e) {
            resolve(false);
        };
    });
    return promise;
}

export function isArray(e) {
    return Object.prototype.toString.call(e) == '[object Array]';
}

// 深拷贝方法
export function deepClone(obj) {
    var copy;

    // Handle the 3 simple types, and null or undefined
    if(obj == null || typeof obj != "object") return obj;

    // Handle Date
    if(obj instanceof Date) {
        copy = new Date();
        copy.setTime(obj.getTime());
        return copy;
    }

    // Handle Array
    if(obj instanceof Array) {
        copy = [];
        for(var i = 0, len = obj.length; i < len; i++) {
            copy[i] = deepClone(obj[i]);
        }
        return copy;
    }

    // Handle Object
    if(obj instanceof Object) {
        copy = {};
        for(var attr in obj) {
            if(obj.hasOwnProperty(attr)) copy[attr] = deepClone(obj[attr]);
        }
        return copy;
    }

    throw new Error("Unable to copy obj! Its type isn't supported.");
}

/**
 * @param {Array} actual
 * @returns {Array}
 */
export function cleanArray(actual) {
    const newArray = [];
    for(let i = 0; i < actual.length; i++) {
        if(actual[i]) {
            newArray.push(actual[i]);
        }
    }
    return newArray;
}

/**
 * @param {Object} json
 * @returns {Array}
 */
export function param(json) {
    if(!json) return '';
    return cleanArray(
        Object.keys(json).map(key => {
            if(json[key] != null || json[key] != undefined) {
                return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
            }
        })
    ).join('&');
}

export function filterKeys(arr = Array, key = String) {
    if(arr instanceof Array) {
        const keys = arr.map(item => {
            return item[key];
        });
        return keys;
    }
    return [];
}

// 金额格式化：1000 -> 1,000.00
export function toMoney(num) {
    var v = num + '';
    var arr = v.split('.');
    return num == 0 && '0.00' || (typeof (num) === 'number' || typeof (num) === 'string') && !isNaN(num - parseFloat(num))
&& (arr[ 0 ].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '.' + (arr.length === 1 && '00'
|| arr.length === 2 && ((parseFloat('0.' + arr[ 1 ]).toFixed(2)).toString().split('.')[ 1 ]))) || num;
}

// 阿拉伯数字转换为简写汉字
export function arabiaToSimplifiedChinese(n) {
    if(n === 0) {
        return "零";
    }
    if(!/^(0|[1-9]\d*)(\.\d+)?$/.test(n)) {
        return "";
    }
    var unit = "仟佰拾亿仟佰拾万仟佰拾元角分";
    var str = "";
    n += "00";
    var p = n.indexOf('.');
    if(p >= 0) {
        n = n.substring(0, p) + n.substr(p + 1, 2);
    }
    unit = unit.substr(unit.length - n.length);
    for(var i = 0; i < n.length; i++) {
        str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i);
    }
    return str.replace(/零(仟|佰|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元整");
}

// 提高浮点数计算精度
export function getResult(money1, money2, isAdd = true) {
    const num1 = new Decimal(money1 || 0);
    const num2 = new Decimal(money2 || 0);
    let result;
    if(isAdd) {
        result = num1.plus(num2);
    }else {
        result = num1.minus(num2);
    }
    return result.toNumber();
}

// 获取最大日期或最小日期
// isMax=true 获取最大日期 反之最小
export function getDaysMax(dataArr, isMax = true) {
    let data = dataArr[0];
    for(let i = 1; i < dataArr.length; i++) {
        if(isMax) {
            if(Date.parse(dataArr[i]) > Date.parse(data)) {
                data = dataArr[i];
            }
        }else {
            if(Date.parse(dataArr[i]) < Date.parse(data)) {
                data = dataArr[i];
            }
        }
    }
    return data;
}


export function fileConvertBase64(file) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    return new Promise((resolve, reject) => {
        reader.onload = e => {
            resolve(e.target.result);
        };
        reader.onerror = e => {
            reject(e);
        };
    });
}

export function base64ConvertFile(data, filename) {
    var arr = data.split(',');
    var type = arr[0].match(/:(.*?);/)[1];
    // var fileExt = type.split('/')[1];
    var bstr = atob(arr[1]);
    var n = bstr.length;
    var u8arr = new Uint8Array(n);
    while(n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], filename, {
        type: type
    });
}

export function getNameByUrl(fileUrl, encode, fileName) {
    if(!fileName) {
        fileName = fileUrl.slice(fileUrl.lastIndexOf('/') + 1);
    }
    if(encode) {
        fileName = encodeURIComponent(fileName);
    }
    return fileName;
}

export function dataForWeek() {
    return [
        { id: 1, label: '一' },
        { id: 2, label: '二' },
        { id: 3, label: '三' },
        { id: 4, label: '四' },
        { id: 5, label: '五' },
        { id: 6, label: '六' },
        { id: 0, label: '日' }
    ];
}

export function openWindow(url, title, w, h) {
    // Fixes dual-screen position                            Most browsers       Firefox
    const dualScreenLeft = window.screenLeft !== undefined ? window.screenLeft : screen.left;
    const dualScreenTop = window.screenTop !== undefined ? window.screenTop : screen.top;

    const width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
    const height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

    const left = ((width / 2) - (w / 2)) + dualScreenLeft;
    const top = ((height / 2) - (h / 2)) + dualScreenTop;
    const newWindow = window.open(url, title, 'toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=yes, copyhistory=no, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

    // Puts focus on the newWindow
    if(window.focus) {
        newWindow.focus();
    }
}

export function filterPackageType(mtypes, mtypeId) {
    var list = mtypes;
    if(mtypeId == 53) {
        // 社区灯箱
        return list.filter(item => item.id > 6 && item.id < 14 && item.id != 10 && item.id != 11);
    }else if(mtypeId == 179) {
        // 社区门禁
        return list.filter(item => item.id > 9 && item.id <= 14 && item.id != 10 && item.id != 11 || item.id == 17);
    }else if(mtypeId == 249) {
        // 人行护栏
        return list.filter(item => (item.id > 9 && item.id <= 14 && item.id != 10 && item.id != 11) || item.id == 17);
    }else if(mtypeId == 56) {
        // 道闸
        return list.filter(item => item.id > 11 && item.id <= 14 || item.id == 17);
    }else if(mtypeId !== 249) {
        return list.filter(item => {
            if(mtypeId == 50 || mtypeId == 266 || mtypeId == 178 || mtypeId == 52 || mtypeId == 57) {
                return item.id < 12;
            }
            return item.id < 14;
        });
    }
    return list;
}
